/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Dec 27 2024
 **/

import { getScaledRectangle, getSourceResolution } from "./utils";

// draw text
export function drawText(
	ctx: CanvasRenderingContext2D,
	points: Vector2[],
	text: string,
	strokeColor: string | CanvasGradient
) {
	ctx.fillStyle = strokeColor;
	ctx.font = "24px Arial";
	ctx.textBaseline = "top";
	ctx.textAlign = "left";

	const x = points[0].x;
	const y = points[0].y;
	ctx.fillText(text, x, y);
}

// draw rect and fill with image
export function drawImageRect(ctx: CanvasRenderingContext2D, points: Vector2[], image: CanvasImageSource) {
	if (points.length < 2) return;
	const imageSize = getSourceResolution(image);
	const { x, y, width, height } = getScaledRectangle(points[0], points[1], imageSize);
	ctx.drawImage(image, x, y, width, height);
}

// Emoji 그리기
export function drawEmojiObject(
	ctx: CanvasRenderingContext2D,
	point: Vector2,
	emojiStyle: IWhiteboardEmojiObject,
	selectedIconIndex: number
) {
	if (emojiStyle && emojiStyle.icons) {
		const { x, y } = point;
		ctx.save();
		ctx.beginPath();
		ctx.drawImage(
			emojiStyle.icons[selectedIconIndex],
			x - emojiStyle.size.width / 2,
			y - emojiStyle.size.height / 2,
			emojiStyle.size.width,
			emojiStyle.size.height
		);
	}
}

// Emoji 포인터 그리기
export function drawEmojiPointer(
	ctx: CanvasRenderingContext2D,
	pointer: coordinateEx,
	emojiStyle: IWhiteboardEmojiObject,
	selectedIconIndex: number
) {
	if (emojiStyle.icons) {
		const { x, y } = pointer;
		if (y > 0)
			ctx.drawImage(
				emojiStyle.icons[selectedIconIndex],
				x - emojiStyle.size.width / 2,
				y - emojiStyle.size.height / 2,
				emojiStyle.size.width,
				emojiStyle.size.height
			);
	}
}
